import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {DataResponse} from "../../../network/service/data.response";
import {AddOrUpdateCategoryOptions} from "../dialog/add-or-update-category/options/add-or-update-category.options";
import {AddOrUpdateCategoryComponent} from "../dialog/add-or-update-category/add-or-update-category.component";
import {AddOrUpdateServicesOptions} from "../dialog/add-or-update-services/options/add-or-update-services.options";
import {AddOrUpdateServicesComponent} from "../dialog/add-or-update-services/add-or-update-services.component";
import {RequestType} from "../../../enums/request.type";
import {Config} from "../../../common/config";
import {FeaturesDialogComponent} from '../dialog/features/features.component';
import {MatDialog} from '@angular/material/dialog';
import {FeaturesOptions} from '../dialog/features/options/features.options';

@Component({
  selector: 'app-menu',
  standalone: false,
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent extends BaseComponent implements OnInit {
  branches?: any[];
  selectedBranchId: string | undefined = undefined;
  isLoadingBranches = false;
  categories: any[] = [];
  selectedCategory?: any;
  isLoadingCategories = false;
  products: any[] = [];
  allProducts: any[] = [];
  isLoadingProducts = false;
  allFilters = FilterUtil.CategoriesFilters;
  filters: any = {};

  constructor(
    injector: Injector,
    private dialog: MatDialog,
  ) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loadBranches();
  }

  override loadOnline() {
    super.loadOnline();
    this.loadBranches();
  }

  loadBranches() {
    this.isLoadingBranches = true;
    this.serviceApi.getBranches(undefined, undefined, undefined, RequestType.ALL, undefined).subscribe((res: DataResponse<any>) => {
      this.isLoadingBranches = false;
      if (res.success) {
        this.branches = res.data;
        if (this.branches && this.branches.length > 0) {
          this.selectedBranchId = this.branches[0].BusinessId;
          this.loadCategories();
        }
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  loadCategories() {
    const branchId = this.selectedBranchId;
    if (!branchId) return;
    this.isLoadingCategories = true;
    this.serviceApi.getCategoryAndTags(undefined, undefined, 'CategoryBranches,CategoryBranches.Branch', RequestType.ALL, branchId, {
      Order: {
        Field: 'Order',
        Type: 'ASC'
      }
    }).subscribe({
      next: (res: ListResponse<any>) => {
        this.isLoadingCategories = false;
        if (res.success && res.data) {
          const data = res.data as any;
          this.categories = data.Categories || [];
          if (this.categories && this.categories.length > 0) {
            this.selectedCategory = this.categories[0];
            this.loadProducts();
          } else {
            this.products = [];
            this.allProducts = [];
          }
        }
      },
      error: () => {
        this.isLoadingCategories = false;
      }
    });
  }

  loadProducts() {
    const branchId = this.selectedBranchId;
    if (!branchId) return;
    this.isLoadingProducts = true;
    let filterValues: any[] = [];
    if (this.selectedCategory) {
      filterValues.push({
        Field: 'CategoryId',
        Type: 'EQ',
        Value: this.selectedCategory.CategoryId
      });
    }
    if (this.filters && this.filters.Values && this.filters.Values.length > 0) {
      filterValues = [...filterValues, ...this.filters.Values];
    }
    let filter: any = null;
    if (filterValues.length > 0) {
      filter = {
        Type: 'AND',
        Values: filterValues
      };
    }
    const filterParam = filter ? {Filter: filter} : {};
    this.serviceApi.getServices(undefined, undefined, 'ServicePrices,ServicePrices.ServicePriceAdditives,ServicePrices.ServicePriceAdditives.Additive,ServicePrices.ServicePriceAdditives.Attribute,ServicePrices.ServicePriceAdditives.Attribute.AttributeType,Category,Tag', RequestType.ALL, undefined, filterParam).subscribe({
      next: (res: ListResponse<any>) => {
        this.isLoadingProducts = false;
        if (res.success) {
          this.allProducts = res.data || [];
          this.products = res.data || [];
        }
      },
      error: () => {
        this.isLoadingProducts = false;
      }
    });
  }

  onBranchClick(branch: any) {
    this.selectedBranchId = branch.BusinessId;
    this.selectedCategory = undefined;
    this.products = [];
    this.allProducts = [];
    this.categories = [];
    this.loadCategories();
  }

  isBranchSelected(branch: any): boolean {
    return this.selectedBranchId === branch.BusinessId;
  }

  onCategoryClick(category: any) {
    this.selectedCategory = category;
    this.loadProducts();
  }

  getCategoryProductCount(categoryId: string): number {
    if (!this.allProducts || this.allProducts.length === 0) return 0;
    return this.allProducts.filter(product => product.CategoryId === categoryId).length;
  }

  checkServicePrice(serviceId: number): boolean {
    let service = this.products.find(product => product.ServiceId === serviceId);
    return !!service.ServicePrices.find((servicePrice: any) => servicePrice.BusinessId === this.selectedBranchId);
  }

  getServicePrice(serviceId: number): any {
    let service = this.products.find(product => product.ServiceId === serviceId);
    return service.ServicePrices.find((servicePrice: any) => servicePrice.BusinessId === this.selectedBranchId);
  }

  getServicePriceRemainedCapacity(serviceId: number, servicePriceId: number): number {
    let servicePrice = this.products.find(product => product.ServiceId === serviceId).ServicePrices.find((servicePrice: any) => servicePrice.BusinessId === this.selectedBranchId);
    return parseInt(servicePrice.MaxCapacity) - parseInt(servicePrice.OrderedCount);
  }

  getSelectedCategoryTitle(): string {
    if (this.selectedCategory && this.categories) {
      const category = this.categories.find(c => c.CategoryId === this.selectedCategory.CategoryId);
      return category?.Title || '';
    }
    return 'همه دسته‌بندی‌ها';
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.loadCategories();
    if (this.selectedCategory) {
      this.loadProducts();
    }
  }

  onCreateCategoryClicked() {
    let addOrUpdateCategoryOptions = new AddOrUpdateCategoryOptions();
    addOrUpdateCategoryOptions.category = {};
    addOrUpdateCategoryOptions.onInsertOrUpdateFinished = () => {
      this.loadCategories();
    };
    let addOrUpdateCategoryComponent = this.matDialog.open(AddOrUpdateCategoryComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateCategoryComponent.componentInstance.addOrUpdateCategoryOptions = addOrUpdateCategoryOptions;
  }

  onUpdateCategoryClicked(category: any) {
    let addOrUpdateCategoryOptions = new AddOrUpdateCategoryOptions();
    addOrUpdateCategoryOptions.category = category;
    addOrUpdateCategoryOptions.onInsertOrUpdateFinished = () => {
      this.loadCategories();
    };
    let addOrUpdateCategoryComponent = this.matDialog.open(AddOrUpdateCategoryComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateCategoryComponent.componentInstance.addOrUpdateCategoryOptions = addOrUpdateCategoryOptions;
  }

  onDeleteCategoryClicked(category: any) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف دسته‌بندی مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteCategories(category.CategoryId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadCategories();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }

  onCreateProductClicked() {
    if (!this.selectedCategory) {
      SnackBarUtil.makeMessage(this, 'لطفا ابتدا یک دسته‌بندی انتخاب کنید', false);
      return;
    }
    Config.selectedBusinessId = this.selectedBranchId;
    let addOrUpdateServicesOptions = new AddOrUpdateServicesOptions();
    addOrUpdateServicesOptions.service = {
      CategoryId: this.selectedCategory.CategoryId,
      BusinessId: this.selectedBranchId
    };
    addOrUpdateServicesOptions.productsAttributes = [];
    addOrUpdateServicesOptions.categoryId = this.selectedCategory.CategoryId;
    addOrUpdateServicesOptions.branchId = this.selectedBranchId;
    addOrUpdateServicesOptions.onInsertOrUpdateFinished = () => {
      this.loadProducts();
    };
    let addOrUpdateServicesComponent = this.matDialog.open(AddOrUpdateServicesComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateServicesComponent.componentInstance.addOrUpdateProductOptions = addOrUpdateServicesOptions;
  }

  onUpdateProductClicked(product: any) {
    Config.selectedBusinessId = this.selectedBranchId;
    let addOrUpdateServicesOptions = new AddOrUpdateServicesOptions();
    addOrUpdateServicesOptions.service = product;
    addOrUpdateServicesOptions.productsAttributes = [];
    addOrUpdateServicesOptions.categoryId = this.selectedCategory.CategoryId;
    addOrUpdateServicesOptions.branchId = this.selectedBranchId;
    addOrUpdateServicesOptions.onInsertOrUpdateFinished = () => {
      this.loadProducts();
    };
    let addOrUpdateServicesComponent = this.matDialog.open(AddOrUpdateServicesComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateServicesComponent.componentInstance.addOrUpdateProductOptions = addOrUpdateServicesOptions;
  }

  onDeleteProductClicked(product: any) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف محصول مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteServices(product.ServiceId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadProducts();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }

  onManageFeaturesClicked(product: any): void {
    let featuresOptions = new FeaturesOptions();
    featuresOptions.product = product;
    featuresOptions.servicePriceId = product.ServicePrices.find((servicePrice: any) => servicePrice.BusinessId === this.selectedBranchId)?.ServicePriceId;
    featuresOptions.branchId = this.selectedBranchId;
    featuresOptions.onAddFinished = () => {
      this.loadProducts();
    };
    let featuresComponent = this.matDialog.open(FeaturesDialogComponent, {
      width: '100%',
      height: 'auto',
      direction: "rtl",
    });
    featuresComponent.componentInstance.featuresOptions = featuresOptions;
  }
}
